import {
  CombinedFormItemNames,
  FormFieldErrorsProps,
} from "@/components/Inputs/FormInputErr/FormFieldErrorsProps.ts";
import { useTranslation } from "react-i18next";

export const FormFieldErrors = (props: FormFieldErrorsProps) => {
  const { t } = useTranslation();
  const { errors, name } = props;

  return Object.keys(errors)?.map((key) => {
    if (name === (key as CombinedFormItemNames))
      return (
        <div key={key} className="formFieldErrWrap c-be-booking-form-errors">
          {
            // @ts-ignore - Works, but types of reactHookForm are not generic
            // eslint-disable-next-line
            errors?.[name]?.type === "required" && <span>{t("form.requiredField")}</span>
          }
          {
            // @ts-ignore - Works, but types of reactHookForm are not generic
            // eslint-disable-next-line
            errors?.[name]?.type === "maxLength" && <span>{t("form.maxLength")}</span>
          }
          {
            // @ts-ignore - Works, but types of reactHookForm are not generic
            // eslint-disable-next-line
            errors?.[name]?.message && <span>{`${errors?.[name]?.message as string}`}</span>
          }
        </div>
      );
  });
};
